import { BiLoader } from "react-icons/bi";

export const LoaderOverlay = () => (
    <div className="w-full h-full absolute left-0 top-0 bg-[#fff]/[.3] z-50 flex justify-center items-center">
        <div className="bg-[#fff] w-12 h-12 flex justify-center items-center rounded-full">
            <BiLoader className="w-8 h-full animate-spin" />
        </div>
    </div>
)